<template>
  <div class="bb-form">
    <div class="bb-form-body">
      <div
        class="bb-form-body-item"
        v-for="input in inputs"
        :key="input.id"
      >
      <div
        v-if="input.title"
        class="bb-form-body-item__label"
      >
        {{input.title}}
      </div>
        <component
          :is="getComponentByType(input)"
          :model="model"
          :input="input"
          @input="setValue($event, input)"
        />
      </div>
    </div>
  </div>
</template>

<script>
import {get, set} from 'lodash'
import BBTextarea from '@/components/Main/Inputs/BBTextarea'
import BBStringSell from '@/components/Main/BBForm/BBStringSell/BBStringSell'
import BBRadio from '@/components/Main/BBForm/BBRadio/BBRadio'
import BBFile from '@/components/Main/BBForm/BBFile/BBFile'

export default {
  name: 'BBForm',
  props: {
    inputs: {
      type: Array,
      default: () => []
    }
  },
  data: () => ({
    model: {},
    errors: {},
    validation: {}
  }),
  methods: {
    getComponentByType (input) {
      const type = get(input, 'type', '')
      switch (type) {
      case 'radio':
        return BBRadio
      case 'textarea':
        return BBTextarea
      case 'file':
        return BBFile
      default:
        return BBStringSell
      }
    },
    setValue (value, input) {
      set(this.model, input.model, value)
      if (input.resetErrors) this.errors = {}
      this.$emit('update', { model: this.model, input, value })
    }
  }
}
</script>

<style scoped lang="scss">
@import "../../../sass/variables";
@import "../../../sass/mixins";

  .bb-form {
    @include global-font;
    display: grid;
    background: $color-white;
  }

  .bb-form-body {
    display: grid;
    grid-gap: 20px 0;
    width: 100%;
    transition: 0.3s;
  }

  .bb-form-body-item {
    display: grid;
    grid-gap: 8px;
    font-size: 14px;
    line-height: 17px;
    position: relative;

    &__label {
      display: flex;
      align-items: center;
      color: $color-accent;
      font-weight: 600;
      font-size: 13px;
      line-height: 16px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Main/BBForm/BBForm.vue